<template>
	<div class="footBox">
		<div class="footMain">
			<div class="infoLeft">
				<p class="mb20 font20">河北省工程咨询协会</p>
				<p>电话：0311-87029658  67265536</p>
				<p class="mt10">协会邮箱：zhangwang@zhbykj.com</p>
				<p class="mt10">技术支持：<a class="balink" href="http://www.zhbykj.com/" target="_blank">河北中惠博裕科技有限公司</a></p>
				<p class="mt10">技术支持联系电话：15369381363</p>
			</div>
			<div class="infoCenter">
				<img class="ewmImg" src="@/assets/home/ewm.jpg" alt="">
				<p class="textc mt5">微信公众号</p>
			</div>
			<div class="infoRight">
				<p class="mb20 font20">友情链接</p>
				<div class="yqBox">
					<img v-for="(item,index) in yqList" :key="index" :src="item.imgUrl" @click="yqClick(item.link)" alt="">
				</div>
			</div>
		</div>
		<p class="textc mt20"><a class="balink" href="https://beian.miit.gov.cn/" target="_blank">冀ICP备2022018659号-1</a></p>
	</div>
</template>

<script>
export default {
	name: 'Footer',
	data() {
		return {
			yqList:[
				{
					imgUrl:require('@/assets/home/yq1.png'),
					link:'https://www.ndrc.gov.cn/'
				},
				{
					imgUrl:require('@/assets/home/yq2.png'),
					link:'https://www.cnaec.com.cn/'
				},
				{
					imgUrl:require('@/assets/home/yq3.png'),
					link:'https://hbdrc.hebei.gov.cn/'
				},
				{
					imgUrl:require('@/assets/home/yq4.png'),
					link:'https://minzheng.hebei.gov.cn/'
				}
			]
		};
	},
	mounted() { },
	methods: {
		//打开页面
		 yqClick(url){
			window.open(url,'_blank')
		 }
	},
};
</script>

<style scoped>
	.footBox{
		width: 100%;
		/* height: 220px; */
		background: #555F68;
		padding-top: 40px;
		padding-bottom: 20px;
		color: #fff;
	}
	.footMain{
		width: 1400px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}
	.infoLeft{
		width: 300px;
	}
	.ewmImg{
		width: 120px;
	}
	.infoRight{
		width: 820px;
	}
	.yqBox{
		display: flex;
		justify-content: space-around;
	}
	.yqBox img{
		width: 190px;
		margin-right: 20px;
		cursor: pointer;
	}
	.yqBox img:last-child{
		margin-right: 0;
	}
	.balink{
		color: #fff;
		text-decoration: none;
	}
</style>
